import AppApiService from '@services/app.api.service';
import JWTService from '@services/jwt.service';

import { decodeJWT } from '@helpers';

import { MutationTypes, ActionTypes } from '@store/modules/app.types';

import { namespace as AuthNamespace } from '@store/modules/auth.types';

export default {
  namespaced: true,
  state: {
    userManagerUrl: JWTService.getUMUrl(),
    clientId: JWTService.getClientId(),
    apiVersion: JWTService.getAPIVersion(),
  },
  mutations: {
    [MutationTypes.SET_UM_URL](state, payload) {
      state.userManagerUrl = payload;
      JWTService.setUMUrl(payload);
    },
    [MutationTypes.SET_CLIENT_ID](state, payload) {
      state.clientId = payload;
      JWTService.setClientId(payload);
    },
    [MutationTypes.SET_API_VERSION](state, payload) {
      state.apiVersion = payload;
      JWTService.setAPIVersion(payload);
    },
  },
  actions: {
    async [ActionTypes.GET_APP_SETTINGS]({ commit }) {
      const { authUrl, version, umClientId } = await AppApiService.getAppSettings();

      commit(MutationTypes.SET_UM_URL, authUrl);
      commit(MutationTypes.SET_CLIENT_ID, umClientId);
      commit(MutationTypes.SET_API_VERSION, version);
    },
  },
  getters: {
    username: (state, getters, { [AuthNamespace]: { token } }) => decodeJWT(token).name,
  },
};
